import React from 'react';
import { Tabs, Tab, Box, InputBase, Stack, alpha } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

// Simple styled input base
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: theme.palette.mode === 'dark' 
    ? theme.palette.text.primary
    : theme.palette.text.primary, // Using primary text color for better visibility
  fontWeight: 500,
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0.5),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
      '&:focus': {
        width: '30ch',
      },
    },
  },
}));

interface TabPanelProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  onSearch: (query: string) => void;
}

const TabPanel: React.FC<TabPanelProps> = ({ activeTab, onTabChange, onSearch }) => {
  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    onTabChange(newValue);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(event.target.value);
  };

  return (
    <Box sx={{ 
      borderBottom: 1, 
      borderColor: 'divider', 
      mb: 3,
      position: 'sticky',
      top: 64, // Height of the header
      zIndex: 10,
      backgroundColor: theme => theme.palette.background.default,
      paddingTop: 1,
      paddingBottom: 1
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          aria-label="flavor tabs"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            flexGrow: 1,
            '& .MuiTabs-flexContainer': {
              gap: 2, // Add space between tab groups
            }
          }}
        >
          {/* Product type tabs */}
          <Tab label="All Flavors" value="all" />
          <Tab label="Pulse Flavors" value="pulse" />
          <Tab label="Pulse X Flavors" value="pulseX" />
          
          {/* Visual divider between tab groups */}
          <Box 
            component="span" 
            sx={{ 
              borderLeft: '1px solid', 
              borderColor: 'divider',
              mx: 2,
              height: 24,
              alignSelf: 'center'
            }} 
          />
          
          {/* User preference tabs */}
          <Tab label="Favorites" value="favorites" />
          <Tab label="Tried Flavors" value="tried" />
        </Tabs>
        
        {/* Simple search bar */}
        <Stack 
          direction="row" 
          alignItems="center" 
          spacing={1} 
          sx={{ ml: 2, mr: 1 }}
        >
          <SearchIcon color="primary" />
          <StyledInputBase
            placeholder="Search flavors..."
            inputProps={{ 'aria-label': 'search' }}
            onChange={handleSearchChange}
          />
        </Stack>
      </Box>
    </Box>
  );
};

export default TabPanel;
